import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { BehaviorSubject, finalize, Observable, take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { User } from 'src/app/models/user.model';
import { MSGraphService } from './services';
import * as fromStore from 'src/app/store/';

@Component({
  selector: 'app-edit-profile-user-dialog',
  templateUrl: 'edit-profile-dialog.component.html',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    CommonModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  styleUrls: ['edit-profile-dialog.component.scss'],
})
export class EditProfileDialogComponent implements OnInit {
  userForm: FormGroup;

  user$: Observable<User>;

  userData: User;

  errorMessage: string = null;

  isSubmittingSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isSubmitting$ = this.isSubmittingSubject.asObservable();

  hasSubmissionErrorSubject: BehaviorSubject<boolean> = new BehaviorSubject(
    false,
  );

  hasSubmissionError$ = this.hasSubmissionErrorSubject.asObservable();

  constructor(
    private graphService: MSGraphService,
    public dialogRef: MatDialogRef<EditProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { firstName: string; lastName: string },
    private store: Store<fromStore.State>,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new fromStore.LoadCurrentUser());

    this.store
      .select(fromStore.getCurrentUser)
      .pipe(take(1))
      .subscribe((user) => {
        this.userData = user;
      });

    this.userForm = this.fb.group({
      id: [this.userData?.Id],
      oktaUserId: [this.userData?.OktaUserId__c],
      firstName: [this.userData?.FirstName || '', Validators.required],
      lastName: [this.userData?.LastName || '', Validators.required],
      email: [this.userData?.Email],
    });
  }

  onSave(): void {
    if (!this.userForm.valid) {
      this.errorMessage = 'Please fill in all required fields correctly.';
      this.isSubmittingSubject.next(false);
      return;
    }

    this.isSubmittingSubject.next(true);

    this.updateUser();
  }

  updateUser(): void {
    const formData = this.userForm.getRawValue();

    this.graphService
      .updateEntraUser(this.userForm.value.oktaUserId, formData)
      .pipe(
        take(1),
        finalize(() => this.isSubmittingSubject.next(false)),
      )
      .subscribe({
        next: () => {
          this.hasSubmissionErrorSubject.next(false);
          this.store.dispatch(new fromStore.LoadCurrentUser());
          this.dialogRef.close(formData);
        },
        error: (error) => {
          this.hasSubmissionErrorSubject.next(true);
          this.errorMessage =
            error?.message || 'An error occurred. Please try again.';
        },
      });
  }

  // TODO: This file will be redone during PHASE 2 of the Okta migration; hence the commented-out methods.
  handleEmailOrPasswordChange(): void {
    // this.authService.clearCache();
    // const redirectUri = `${environment.siteUrl}/dashboard`;
    // const passwordResetUrl = `https://mynitel.b2clogin.com/${entraConfig.tenantId}/oauth2/v2.0/authorize?p=${entraConfig.userFlows.passwordReset}&client_id=${entraConfig.clientId}&nonce=defaultNonce&redirect_uri=${redirectUri}&scope=openid&response_type=id_token&prompt=login`;
    // window.location.href = passwordResetUrl;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
